import { Component, OnInit, ChangeDetectionStrategy, OnDestroy, inject } from '@angular/core';
import { HttpService } from '../services/http.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Partner } from '../model/partner.model';
import { BehaviorSubject, of, Subscription } from 'rxjs';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';
import { WindowService } from '@shared/window/window.service';
import { RoutingTabTitleService } from '@shared/service/routing-tab-title/routing-tab-title.service';
import { LocalizeRouterService } from '@app/i18n';
import { PartnerBasicComponent } from '../components/partner-basic/partner-basic.component';
import { PartnerStoresComponent } from '../components/partner-stores/partner-stores.component';
import { OurPartnersLogosComponent } from '../../our-showroom/components/our-partners-logos/our-partners-logos.component';
import { AsyncPipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-partner',
    templateUrl: './partner.component.html',
    styleUrls: ['./partner.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [HttpService],
    imports: [PartnerBasicComponent, PartnerStoresComponent, OurPartnersLogosComponent, AsyncPipe, TranslatePipe],
})
export class PartnerComponent implements OnInit, OnDestroy {
    private router = inject(Router);
    private activatedRoute = inject(ActivatedRoute);
    private httpService = inject(HttpService);
    private windowService = inject(WindowService);
    private routingTabTitleService = inject(RoutingTabTitleService);
    private localizeRouterService = inject(LocalizeRouterService);

    partner$ = new BehaviorSubject<Partner | null>(null);

    private subscriptions = new Subscription();

    ngOnInit(): void {
        this.subscriptions.add(
            this.activatedRoute.params
                .pipe(
                    map((params) => {
                        return params['slug'];
                    }),
                    mergeMap((slug) => {
                        return this.httpService.getPartner(slug);
                    }),
                    tap((partner) => {
                        this.partner$.next(partner);
                        this.displayTranslatedProduct(partner.name);
                        this.windowService.scrollTop();
                    }),
                    catchError(() => {
                        void this.router.navigate(this.localizeRouterService.translateRoute(['/not-found']), { skipLocationChange: true });
                        return of(null);
                    }),
                )
                .subscribe(),
        );
    }

    displayTranslatedProduct(partnerName: string): void {
        const translatedTitle = this.routingTabTitleService.translateTitle('PAGE.TITLE', 'partner');
        this.routingTabTitleService.setTitle(`${translatedTitle}: ${partnerName} | PZ Stelmach`);
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
